// Generated by purs version 0.15.16
import * as API_Account from "../API.Account/index.js";
import * as App_Msg from "../App.Msg/index.js";
import * as App_Operation_Store from "../App.Operation.Store/index.js";
import * as App_Operation_Types from "../App.Operation.Types/index.js";
import * as App_Route from "../App.Route/index.js";
import * as App_State from "../App.State/index.js";
import * as App_Step from "../App.Step/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as $$Error from "../Error/index.js";
import * as Form_StudentSelect from "../Form.StudentSelect/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_FormPicker from "../Steps.FormPicker/index.js";
import * as Steps_Step1_State from "../Steps.Step1.State/index.js";
import * as Steps_Step1_Update from "../Steps.Step1.Update/index.js";
import * as Steps_Step3_State from "../Steps.Step3.State/index.js";
import * as Steps_Step3_Transition from "../Steps.Step3.Transition/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_Step3_Update from "../Steps.Step3.Update/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_DocumentIndex from "../Steps.WorkQueue.DocumentIndex/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Steps_WorkQueue_UIState from "../Steps.WorkQueue.UIState/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
import * as Translate from "../Translate/index.js";
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var nub = /* #__PURE__ */ Data_Array.nub(ordRNTY);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var eq = /* #__PURE__ */ Data_Eq.eq(eqRNTY);
var elem = /* #__PURE__ */ Data_Array.elem(eqRNTY);
var eq2 = /* #__PURE__ */ Data_Eq.eq(App_Operation_Types.eqOperationId);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var isEmpty = /* #__PURE__ */ Internal_SelectionMap.isEmpty(ordRNTY);
var eq3 = /* #__PURE__ */ Data_Eq.eq(API_Account.eqAccType);
var select$prime = /* #__PURE__ */ Internal_SelectionMap["select$prime"](ordRNTY);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var SyncRoute = /* #__PURE__ */ (function () {
    function SyncRoute(value0) {
        this.value0 = value0;
    };
    SyncRoute.create = function (value0) {
        return new SyncRoute(value0);
    };
    return SyncRoute;
})();
var HydrateLocation = /* #__PURE__ */ (function () {
    function HydrateLocation(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    HydrateLocation.create = function (value0) {
        return function (value1) {
            return new HydrateLocation(value0, value1);
        };
    };
    return HydrateLocation;
})();
var RunStep1InitialLoad = /* #__PURE__ */ (function () {
    function RunStep1InitialLoad(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1InitialLoad.create = function (value0) {
        return function (value1) {
            return new RunStep1InitialLoad(value0, value1);
        };
    };
    return RunStep1InitialLoad;
})();
var DebounceStep1Search = /* #__PURE__ */ (function () {
    function DebounceStep1Search(value0) {
        this.value0 = value0;
    };
    DebounceStep1Search.create = function (value0) {
        return new DebounceStep1Search(value0);
    };
    return DebounceStep1Search;
})();
var RunStep1Search = /* #__PURE__ */ (function () {
    function RunStep1Search(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1Search.create = function (value0) {
        return function (value1) {
            return new RunStep1Search(value0, value1);
        };
    };
    return RunStep1Search;
})();
var RunStep1PageChange = /* #__PURE__ */ (function () {
    function RunStep1PageChange(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep1PageChange.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep1PageChange(value0, value1, value2);
            };
        };
    };
    return RunStep1PageChange;
})();
var RunStep1CurrentPageReload = /* #__PURE__ */ (function () {
    function RunStep1CurrentPageReload(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1CurrentPageReload.create = function (value0) {
        return function (value1) {
            return new RunStep1CurrentPageReload(value0, value1);
        };
    };
    return RunStep1CurrentPageReload;
})();
var RunStep1SaveFormOrder = /* #__PURE__ */ (function () {
    function RunStep1SaveFormOrder(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1SaveFormOrder.create = function (value0) {
        return function (value1) {
            return new RunStep1SaveFormOrder(value0, value1);
        };
    };
    return RunStep1SaveFormOrder;
})();
var RunStep1ToggleLocks = /* #__PURE__ */ (function () {
    function RunStep1ToggleLocks(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1ToggleLocks.create = function (value0) {
        return function (value1) {
            return new RunStep1ToggleLocks(value0, value1);
        };
    };
    return RunStep1ToggleLocks;
})();
var RunStep1CopyDocuments = /* #__PURE__ */ (function () {
    function RunStep1CopyDocuments(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep1CopyDocuments.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep1CopyDocuments(value0, value1, value2);
            };
        };
    };
    return RunStep1CopyDocuments;
})();
var RunStep1DeleteDocuments = /* #__PURE__ */ (function () {
    function RunStep1DeleteDocuments(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1DeleteDocuments.create = function (value0) {
        return function (value1) {
            return new RunStep1DeleteDocuments(value0, value1);
        };
    };
    return RunStep1DeleteDocuments;
})();
var RunStep1ExportDocuments = /* #__PURE__ */ (function () {
    function RunStep1ExportDocuments(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep1ExportDocuments.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep1ExportDocuments(value0, value1, value2);
            };
        };
    };
    return RunStep1ExportDocuments;
})();
var RunStep1RequestSignatures = /* #__PURE__ */ (function () {
    function RunStep1RequestSignatures(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep1RequestSignatures.create = function (value0) {
        return function (value1) {
            return new RunStep1RequestSignatures(value0, value1);
        };
    };
    return RunStep1RequestSignatures;
})();
var RunStep1UpdateForms = /* #__PURE__ */ (function () {
    function RunStep1UpdateForms(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep1UpdateForms.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep1UpdateForms(value0, value1, value2);
            };
        };
    };
    return RunStep1UpdateForms;
})();
var RunStep2AInitialLoad = /* #__PURE__ */ (function () {
    function RunStep2AInitialLoad(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep2AInitialLoad.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep2AInitialLoad(value0, value1, value2);
            };
        };
    };
    return RunStep2AInitialLoad;
})();
var RunStep2BLoad = /* #__PURE__ */ (function () {
    function RunStep2BLoad(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    RunStep2BLoad.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new RunStep2BLoad(value0, value1, value2, value3);
                };
            };
        };
    };
    return RunStep2BLoad;
})();
var RunStep2ExportAll = /* #__PURE__ */ (function () {
    function RunStep2ExportAll(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep2ExportAll.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep2ExportAll(value0, value1, value2);
            };
        };
    };
    return RunStep2ExportAll;
})();
var RunStep3FormTypesLoad = /* #__PURE__ */ (function () {
    function RunStep3FormTypesLoad(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RunStep3FormTypesLoad.create = function (value0) {
        return function (value1) {
            return new RunStep3FormTypesLoad(value0, value1);
        };
    };
    return RunStep3FormTypesLoad;
})();
var RunStep3InitialLoad = /* #__PURE__ */ (function () {
    function RunStep3InitialLoad(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep3InitialLoad.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep3InitialLoad(value0, value1, value2);
            };
        };
    };
    return RunStep3InitialLoad;
})();
var SyncStep3Route = /* #__PURE__ */ (function () {
    function SyncStep3Route(value0) {
        this.value0 = value0;
    };
    SyncStep3Route.create = function (value0) {
        return new SyncStep3Route(value0);
    };
    return SyncStep3Route;
})();
var ScrollStep3Section = /* #__PURE__ */ (function () {
    function ScrollStep3Section(value0) {
        this.value0 = value0;
    };
    ScrollStep3Section.create = function (value0) {
        return new ScrollStep3Section(value0);
    };
    return ScrollStep3Section;
})();
var SaveStep3 = /* #__PURE__ */ (function () {
    function SaveStep3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    SaveStep3.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new SaveStep3(value0, value1, value2);
            };
        };
    };
    return SaveStep3;
})();
var LoadStep3 = /* #__PURE__ */ (function () {
    function LoadStep3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    LoadStep3.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new LoadStep3(value0, value1, value2);
            };
        };
    };
    return LoadStep3;
})();
var AutofillStep3 = /* #__PURE__ */ (function () {
    function AutofillStep3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    AutofillStep3.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new AutofillStep3(value0, value1, value2);
            };
        };
    };
    return AutofillStep3;
})();
var ToggleStep3Lock = /* #__PURE__ */ (function () {
    function ToggleStep3Lock(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ToggleStep3Lock.create = function (value0) {
        return function (value1) {
            return new ToggleStep3Lock(value0, value1);
        };
    };
    return ToggleStep3Lock;
})();
var RunStep3DocumentMutation = /* #__PURE__ */ (function () {
    function RunStep3DocumentMutation(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RunStep3DocumentMutation.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RunStep3DocumentMutation(value0, value1, value2);
            };
        };
    };
    return RunStep3DocumentMutation;
})();
var ConfirmStep3Cancel = /* #__PURE__ */ (function () {
    function ConfirmStep3Cancel() {

    };
    ConfirmStep3Cancel.value = new ConfirmStep3Cancel();
    return ConfirmStep3Cancel;
})();
var AllowPageUnload = /* #__PURE__ */ (function () {
    function AllowPageUnload() {

    };
    AllowPageUnload.value = new AllowPageUnload();
    return AllowPageUnload;
})();
var BlockPageUnload = /* #__PURE__ */ (function () {
    function BlockPageUnload() {

    };
    BlockPageUnload.value = new BlockPageUnload();
    return BlockPageUnload;
})();
var OpenExportUrl = /* #__PURE__ */ (function () {
    function OpenExportUrl(value0) {
        this.value0 = value0;
    };
    OpenExportUrl.create = function (value0) {
        return new OpenExportUrl(value0);
    };
    return OpenExportUrl;
})();
var OpenExternalUrl = /* #__PURE__ */ (function () {
    function OpenExternalUrl(value0) {
        this.value0 = value0;
    };
    OpenExternalUrl.create = function (value0) {
        return new OpenExternalUrl(value0);
    };
    return OpenExternalUrl;
})();
var ReportError = /* #__PURE__ */ (function () {
    function ReportError(value0) {
        this.value0 = value0;
    };
    ReportError.create = function (value0) {
        return new ReportError(value0);
    };
    return ReportError;
})();
var syncStep2BState = function (state) {
    return function (ready) {
        return {
            route: state.route,
            step: state.step,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step3: state.step3,
            routeVersion: state.routeVersion,
            step2B: new App_State.Step2BReady(ready),
            workQueueState: ready.workQueueState,
            workQueueUi: ready.workQueueUi,
            workQueueCache: ready.workQueueCache
        };
    };
};
var syncReadyState = function (state) {
    return function (ready) {
        return {
            route: state.route,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            routeVersion: state.routeVersion,
            workQueueState: ready.editor.workQueueState,
            workQueueUi: ready.editor.workQueueUi,
            workQueueCache: ready.editor.workQueueCache,
            step: new App_Step.Step3Doc(ready.editor.fillState.doc.id),
            step3: new App_State.Step3Ready(ready)
        };
    };
};
var supersededScopesForStep2Operation = function (v) {
    if (v instanceof App_Operation_Types.LoadStep2Students) {
        return [ App_Operation_Types.Step2StudentSelectScope.value ];
    };
    if (v instanceof App_Operation_Types.LoadStep2FormPicker) {
        return [ App_Operation_Types.Step2FormPickerScope.value ];
    };
    return [  ];
};
var supersededScopesForStep1Operation = function (v) {
    if (v instanceof App_Operation_Types.LoadRecentForms) {
        return [ App_Operation_Types.Step1RecentFormsScope.value ];
    };
    return [  ];
};
var supersedeLatestActiveInScope = function (scope) {
    return function (state) {
        var v = App_Operation_Store.lookupLatestInScope(state.operations)(scope);
        if (v instanceof Data_Maybe.Just && App_Operation_Store.isOperationActive(state.operations)(v.value0.id)) {
            return {
                route: state.route,
                step: state.step,
                workQueueState: state.workQueueState,
                workQueueUi: state.workQueueUi,
                workQueueCache: state.workQueueCache,
                preselectForms: state.preselectForms,
                pushStateInterface: state.pushStateInterface,
                step1: state.step1,
                step2A: state.step2A,
                step2B: state.step2B,
                step3: state.step3,
                routeVersion: state.routeVersion,
                operations: App_Operation_Store.markSuperseded(v.value0.id)(state.operations)
            };
        };
        return state;
    };
};
var step3WorkQueueUi = function (state) {
    if (state.step3 instanceof App_State.Step3Ready) {
        return state.step3.value0.editor.workQueueUi;
    };
    return state.workQueueUi;
};
var step3WorkQueueState = function (state) {
    if (state.step3 instanceof App_State.Step3Ready) {
        return state.step3.value0.editor.workQueueState;
    };
    return state.workQueueState;
};
var step3WorkQueueDocIds = function (workQueue) {
    return nub(append(map(function (v) {
        return v.id;
    })(workQueue.editDocs))(map(function (v) {
        return v.id;
    })(fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(workQueue.documents)))));
};
var step3WorkQueueCache = function (state) {
    if (state.step3 instanceof App_State.Step3Ready) {
        return state.step3.value0.editor.workQueueCache;
    };
    return state.workQueueCache;
};
var step3DocumentMutationOperationKind = function (currentDocId) {
    var requestDocIds = function (requests) {
        var docIds = nub(map(function (v) {
            return v.docId;
        })(requests));
        var $165 = Data_Array["null"](docIds);
        if ($165) {
            return [ currentDocId ];
        };
        return docIds;
    };
    return function (v) {
        if (v instanceof Steps_Step3_Types.CreateComment) {
            return new App_Operation_Types.CreateStep3Comment(v.value0);
        };
        if (v instanceof Steps_Step3_Types.UpdateComment) {
            return new App_Operation_Types.UpdateStep3Comment(v.value0);
        };
        if (v instanceof Steps_Step3_Types.DeleteComment) {
            return new App_Operation_Types.DeleteStep3Comment(v.value0);
        };
        if (v instanceof Steps_Step3_Types.CreateAttachment) {
            return new App_Operation_Types.CreateStep3Attachment(v.value0);
        };
        if (v instanceof Steps_Step3_Types.DeleteAttachment) {
            return new App_Operation_Types.DeleteStep3Attachment(v.value0);
        };
        if (v instanceof Steps_Step3_Types.SignWithCapturedSignature) {
            return new App_Operation_Types.SignStep3Document(v.value0);
        };
        if (v instanceof Steps_Step3_Types.SignWithSavedSignature) {
            return new App_Operation_Types.SignStep3DocumentWithSaved(v.value0);
        };
        if (v instanceof Steps_Step3_Types.RefreshSignatureGroup) {
            return new App_Operation_Types.RefreshStep3Signatures(v.value0);
        };
        if (v instanceof Steps_Step3_Types.RequestSignatures) {
            return new App_Operation_Types.RequestStep3Signatures(requestDocIds(v.value0));
        };
        throw new Error("Failed pattern match at App.Update (line 1095, column 51 - line 1113, column 56): " + [ v.constructor.name ]);
    };
};
var step3DocRouteIndex = function (ready) {
    return function (docId) {
        var matchesDoc = function (entry) {
            if (entry.form instanceof Data_Either.Left) {
                return eq(entry.form.value0.id)(docId);
            };
            if (entry.form instanceof Data_Either.Right) {
                var v = Steps_WorkQueue_Cache.getDocByStudent(ready.editor.workQueueState)({
                    studentId: entry.student,
                    formId: entry.form.value0,
                    documentId: Data_Maybe.Nothing.value
                });
                if (v instanceof Data_Maybe.Just) {
                    return eq(v.value0.id)(docId);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return false;
                };
                throw new Error("Failed pattern match at App.Update (line 1315, column 25 - line 1317, column 29): " + [ v.constructor.name ]);
            };
            throw new Error("Failed pattern match at App.Update (line 1313, column 24 - line 1317, column 29): " + [ entry.form.constructor.name ]);
        };
        return Data_Array.findIndex(matchesDoc)(ready.editor.queue);
    };
};
var step3DocIds = function (ready) {
    return nub(append(map(function (v) {
        return v.id;
    })(ready.editor.workQueueState.editDocs))(map(function (v) {
        return v.id;
    })(fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(ready.editor.workQueueState.documents)))));
};
var step3RequestedDocIdsMatch = function (ready) {
    return function (requestedDocIds) {
        var expectedDocIds = step3DocIds(ready);
        var dedupedRequested = nub(requestedDocIds);
        return Data_Array.length(dedupedRequested) === Data_Array.length(expectedDocIds) && Data_Array.all(function (docId) {
            return elem(docId)(expectedDocIds);
        })(dedupedRequested);
    };
};
var step2ExportError = function (err) {
    return function (state) {
        if (state.step instanceof App_Step.Step2A) {
            return {
                state: {
                    route: state.route,
                    step: state.step,
                    workQueueState: state.workQueueState,
                    workQueueUi: state.workQueueUi,
                    workQueueCache: state.workQueueCache,
                    preselectForms: state.preselectForms,
                    pushStateInterface: state.pushStateInterface,
                    operations: state.operations,
                    step1: state.step1,
                    step2B: state.step2B,
                    step3: state.step3,
                    routeVersion: state.routeVersion,
                    step2A: new App_State.Step2ALoadFailed(err)
                },
                commands: [  ]
            };
        };
        if (state.step instanceof App_Step.Step2B) {
            return {
                state: {
                    route: state.route,
                    step: state.step,
                    workQueueState: state.workQueueState,
                    workQueueUi: state.workQueueUi,
                    workQueueCache: state.workQueueCache,
                    preselectForms: state.preselectForms,
                    pushStateInterface: state.pushStateInterface,
                    operations: state.operations,
                    step1: state.step1,
                    step2A: state.step2A,
                    step3: state.step3,
                    routeVersion: state.routeVersion,
                    step2B: new App_State.Step2BLoadFailed(err)
                },
                commands: [  ]
            };
        };
        return {
            state: state,
            commands: [ new ReportError(err) ]
        };
    };
};
var step1BlockingOperationScopes = /* #__PURE__ */ (function () {
    return [ App_Operation_Types.Step1DocumentMutationScope.value, App_Operation_Types.Step1FormOrderScope.value, App_Operation_Types.Step1ExportScope.value ];
})();
var startStep3Operation = function (step3Command) {
    return function (_kind) {
        return function (_generation) {
            return function (mkCommand) {
                return function (result) {
                    if (result.state.step3 instanceof App_State.Step3Ready) {
                        var v = App_Operation_Store.reserveOperationId(result.state.operations);
                        var nextReady = Steps_Step3_Update.applyStartedCommand(result.state.step3.value0)(step3Command)(v.value0);
                        var nextState = (function () {
                            var v1 = syncReadyState(result.state)(nextReady);
                            return {
                                preselectForms: v1.preselectForms,
                                pushStateInterface: v1.pushStateInterface,
                                route: v1.route,
                                routeVersion: v1.routeVersion,
                                step: v1.step,
                                step1: v1.step1,
                                step2A: v1.step2A,
                                step2B: v1.step2B,
                                step3: v1.step3,
                                workQueueCache: v1.workQueueCache,
                                workQueueState: v1.workQueueState,
                                workQueueUi: v1.workQueueUi,
                                operations: v.value1
                            };
                        })();
                        return {
                            state: nextState,
                            commands: append(result.commands)([ mkCommand(v.value0) ])
                        };
                    };
                    return result;
                };
            };
        };
    };
};
var setStep1Ready = function (ready) {
    return function (state) {
        return {
            route: state.route,
            step: state.step,
            workQueueState: state.workQueueState,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            step1: new App_State.Step1Ready(ready),
            workQueueUi: {
                expandedStudents: state.workQueueUi.expandedStudents,
                teacher: state.workQueueUi.teacher,
                semester: state.workQueueUi.semester,
                search: ready.searchState
            }
        };
    };
};
var step1Error = function (err) {
    return function (state) {
        if (state.step1 instanceof App_State.Step1Ready) {
            return {
                state: setStep1Ready(Steps_Step1_State.setError(err)(state.step1.value0))(state),
                commands: [ new ReportError(err) ]
            };
        };
        return {
            state: state,
            commands: [ new ReportError(err) ]
        };
    };
};
var scheduleStep3BootstrapOps = function (result) {
    if (result.state.step3 instanceof App_State.Step3LoadingFormTypes && result.state.step3.value0.opId instanceof Data_Maybe.Nothing) {
        var v = App_Operation_Store.reserveOperationId(result.state.operations);
        return {
            state: {
                route: result.state.route,
                step: result.state.step,
                workQueueState: result.state.workQueueState,
                workQueueUi: result.state.workQueueUi,
                workQueueCache: result.state.workQueueCache,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                routeVersion: result.state.routeVersion,
                operations: v.value1,
                step3: new App_State.Step3LoadingFormTypes({
                    init: result.state.step3.value0.init,
                    opId: new Data_Maybe.Just(v.value0)
                })
            },
            commands: append(result.commands)([ new RunStep3FormTypesLoad(v.value0, result.state.step3.value0.init) ])
        };
    };
    if (result.state.step3 instanceof App_State.Step3LoadingInitialState && result.state.step3.value0.opId instanceof Data_Maybe.Nothing) {
        var kind = Steps_Step3_State.initialLoadOperationKind(result.state.workQueueState)(result.state.step3.value0.init.doc);
        var v = App_Operation_Store.reserveOperationId(result.state.operations);
        return {
            state: {
                route: result.state.route,
                step: result.state.step,
                workQueueState: result.state.workQueueState,
                workQueueUi: result.state.workQueueUi,
                workQueueCache: result.state.workQueueCache,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                routeVersion: result.state.routeVersion,
                operations: v.value1,
                step3: new App_State.Step3LoadingInitialState({
                    init: result.state.step3.value0.init,
                    opId: new Data_Maybe.Just(v.value0)
                })
            },
            commands: append(result.commands)([ new RunStep3InitialLoad(v.value0, kind, result.state.step3.value0.init) ])
        };
    };
    return result;
};
var missingStep2ExportReportError = /* #__PURE__ */ (function () {
    return new $$Error.WithContext(new $$Error.InModule("App.Update"), new $$Error.WithContext(new $$Error.DuringAction("exporting selected forms"), new $$Error.StringError("Expected at least one report for exported forms.")));
})();
var loadingStep3Route = function (locationState) {
    return function (workQueue) {
        return new App_Route.RStep3({
            preservedQuery: App_Route.preserveQuery(locationState.search),
            activeDoc: Data_Maybe.Nothing.value,
            docs: nub(step3WorkQueueDocIds(workQueue)),
            section: App_Route.SectionClear.value
        });
    };
};
var isStep1RecentFormsReloadMsg = function (v) {
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.SearchChanged) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.ChangePage) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.FormPickerChanged) {
        return !v.value0.value0.reorder;
    };
    return false;
};
var isStep1Loading = function (step1State) {
    if (step1State.state instanceof Steps_Step1_State.RFLoading) {
        return true;
    };
    return false;
};
var isStep1GlobalActionMsg = function (v) {
    if (v instanceof Steps_Step1_Update.ViewAction) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.CopyStudentsSelected && v.value0 instanceof Data_Maybe.Just) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.DeleteConfirmed && v.value0) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.SignatureRequestsSelected && v.value0 instanceof Data_Maybe.Just) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.FormsUpdateSelected && v.value0 instanceof Data_Maybe.Just) {
        return true;
    };
    return false;
};
var isStep1FormOrderMsg = function (v) {
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.FormPickerChanged) {
        return v.value0.value0.reorder;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.StartFormReorder) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.SaveFormOrder) {
        return true;
    };
    return false;
};
var isStep1DocumentMutationMsg = function (v) {
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.ToggleDocumentLocks) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.CopyDocuments) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.DeleteDocuments) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.RequestSignatures) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.UpdateForms) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.CopyStudentsSelected && v.value0 instanceof Data_Maybe.Just) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.DeleteConfirmed && v.value0) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.SignatureRequestsSelected && v.value0 instanceof Data_Maybe.Just) {
        return true;
    };
    if (v instanceof Steps_Step1_Update.FormsUpdateSelected && v.value0 instanceof Data_Maybe.Just) {
        return true;
    };
    return false;
};
var isStep1CreateFormsMsg = function (v) {
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.CreateForms) {
        return true;
    };
    return false;
};
var isLatestOperation = function (scope) {
    return function (opId) {
        return function (state) {
            var v = App_Operation_Store.lookupLatestInScope(state.operations)(scope);
            if (v instanceof Data_Maybe.Just) {
                return eq2(v.value0.id)(opId);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return false;
            };
            throw new Error("Failed pattern match at App.Update (line 975, column 38 - line 977, column 21): " + [ v.constructor.name ]);
        };
    };
};
var isCurrentStep2 = function (v) {
    if (v instanceof App_Step.Step2A) {
        return true;
    };
    if (v instanceof App_Step.Step2B) {
        return true;
    };
    return false;
};
var isCurrentOperation = function (scope) {
    return function (opId) {
        return function (state) {
            return isLatestOperation(scope)(opId)(state) && App_Operation_Store.isOperationActive(state.operations)(opId);
        };
    };
};
var invalidatesStep1SearchDebounce = function (v) {
    if (v instanceof Steps_Step1_Update.ViewAction && v.value0 instanceof Steps_Step1_Update.SearchChanged) {
        return false;
    };
    return true;
};
var hasHydrateCommand = /* #__PURE__ */ (function () {
    var isHydrate = function (v) {
        if (v instanceof HydrateLocation) {
            return true;
        };
        return false;
    };
    return Data_Array.any(isHydrate);
})();
var exitToHome = function (state) {
    var editedDocumentIds = map(function (v) {
        return v.id;
    })(state.workQueueState.editDocs);
    var defTeacher = map1(function (v) {
        return v.value;
    })(state.workQueueCache.defTeacher);
    var defSemester = map1(function (v) {
        return v.value;
    })(state.workQueueCache.defSemester);
    var createdDocumentIds = map(function (v) {
        return v.id;
    })(fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(state.workQueueState.documents)));
    return App_State.activateStep(App_Step.Step1.value)({
        route: state.route,
        step: state.step,
        workQueueCache: state.workQueueCache,
        pushStateInterface: state.pushStateInterface,
        operations: state.operations,
        step1: state.step1,
        step2A: state.step2A,
        step2B: state.step2B,
        step3: state.step3,
        routeVersion: state.routeVersion,
        workQueueState: Steps_WorkQueue_State.resetWorkQueueState(defTeacher)(defSemester)(state.workQueueState),
        workQueueUi: Steps_WorkQueue_UIState.resetWorkQueueUiState(state.workQueueCache.defTeacher)(state.workQueueCache.defSemester)(state.workQueueUi),
        preselectForms: nub(append(editedDocumentIds)(createdDocumentIds))
    });
};
var finishStepNavigation = function (state) {
    if (state.step instanceof App_Step.Step2A) {
        return App_State.activateStep((function () {
            var $262 = Data_Map_Internal.isEmpty(state.workQueueState.forms.sel);
            if ($262) {
                return App_Step.Step2B.value;
            };
            return App_Step.Step3.value;
        })())(state);
    };
    if (state.step instanceof App_Step.Step2B) {
        return App_State.activateStep((function () {
            var $263 = isEmpty(state.workQueueState.students);
            if ($263) {
                return App_Step.Step2A.value;
            };
            return App_Step.Step3.value;
        })())(state);
    };
    if (state.step instanceof App_Step.Step3) {
        return exitToHome(state);
    };
    if (state.step instanceof App_Step.Step3Doc) {
        return exitToHome(state);
    };
    return state;
};
var currentRouteForState = function (state) {
    return function (locationState) {
        var loadingRouteFallback = (function () {
            if (state.step instanceof App_Step.Step3) {
                return loadingStep3Route(locationState)(state.workQueueState);
            };
            return App_Route.routeForStepAndWorkQueueState(locationState)(state.step)(state.workQueueState);
        })();
        if (state.step3 instanceof App_State.Step3Ready) {
            return new App_Route.RStep3({
                preservedQuery: App_Route.preserveQuery(locationState.search),
                activeDoc: new Data_Maybe.Just(state.step3.value0.editor.fillState.doc.id),
                docs: nub(step3DocIds(state.step3.value0)),
                section: state.step3.value0.editor.sectionIntent
            });
        };
        if (state.step3 instanceof App_State.Step3LoadingFormTypes) {
            return loadingRouteFallback;
        };
        if (state.step3 instanceof App_State.Step3LoadingInitialState) {
            return loadingRouteFallback;
        };
        return App_Route.routeForStepAndWorkQueueState(locationState)(state.step)(state.workQueueState);
    };
};
var browserRouteStep3Result = function (result) {
    var updateTransitionState = function (editor) {
        return {
            activeSection: editor.activeSection,
            anchor: editor.anchor,
            fillState: editor.fillState,
            position: editor.position,
            queue: editor.queue,
            sectionIntent: editor.sectionIntent,
            workQueueCache: editor.workQueueCache,
            workQueueState: editor.workQueueState,
            workQueueUi: editor.workQueueUi,
            transitionState: {
                active: editor.transitionState.active,
                nextGeneration: editor.transitionState.nextGeneration,
                latest: map1(function (pending) {
                    return {
                        anchor: pending.anchor,
                        generation: pending.generation,
                        position: pending.position,
                        historyMode: Steps_Step3_Transition.ReplaceStep3History.value
                    };
                })(editor.transitionState.latest)
            }
        };
    };
    var updateCommand = function (v) {
        if (v instanceof Steps_Step3_Update.SyncRoute) {
            return new Steps_Step3_Update.SyncRoute(Steps_Step3_Transition.ReplaceStep3History.value);
        };
        return v;
    };
    return {
        state: Steps_Step3_State.mapEditorState(updateTransitionState)(result.state),
        commands: map(updateCommand)(result.commands)
    };
};
var applyStep2OperationStartPolicy = function (kind) {
    return function (state) {
        return Data_Array.foldl(function (acc) {
            return function (scope) {
                return supersedeLatestActiveInScope(scope)(acc);
            };
        })(state)(supersededScopesForStep2Operation(kind));
    };
};
var scheduleStep2BootstrapOps = function (result) {
    if (result.state.step instanceof App_Step.Step2A && hasHydrateCommand(result.commands)) {
        return result;
    };
    if (result.state.step instanceof App_Step.Step2A) {
        if (result.state.step2A instanceof App_State.Step2ALoading && result.state.step2A.value0.opId instanceof Data_Maybe.Nothing) {
            var nextState = applyStep2OperationStartPolicy(App_Operation_Types.LoadStep2Students.value)(result.state);
            var v = App_Operation_Store.reserveOperationId(nextState.operations);
            return {
                state: {
                    route: nextState.route,
                    step: nextState.step,
                    workQueueState: nextState.workQueueState,
                    workQueueUi: nextState.workQueueUi,
                    workQueueCache: nextState.workQueueCache,
                    preselectForms: nextState.preselectForms,
                    pushStateInterface: nextState.pushStateInterface,
                    step1: nextState.step1,
                    step2B: nextState.step2B,
                    step3: nextState.step3,
                    routeVersion: nextState.routeVersion,
                    operations: v.value1,
                    step2A: new App_State.Step2ALoading({
                        workQueueState: result.state.step2A.value0.workQueueState,
                        workQueueCache: result.state.step2A.value0.workQueueCache,
                        opId: new Data_Maybe.Just(v.value0)
                    })
                },
                commands: append(result.commands)([ new RunStep2AInitialLoad(v.value0, result.state.step2A.value0.workQueueState, result.state.step2A.value0.workQueueCache) ])
            };
        };
        return result;
    };
    if (result.state.step instanceof App_Step.Step2B && hasHydrateCommand(result.commands)) {
        return result;
    };
    if (result.state.step instanceof App_Step.Step2B) {
        if (result.state.step2B instanceof App_State.Step2BLoading && result.state.step2B.value0.opId instanceof Data_Maybe.Nothing) {
            var nextState = applyStep2OperationStartPolicy(App_Operation_Types.LoadStep2FormPicker.value)(result.state);
            var v = App_Operation_Store.reserveOperationId(nextState.operations);
            return {
                state: {
                    route: nextState.route,
                    step: nextState.step,
                    workQueueState: nextState.workQueueState,
                    workQueueUi: nextState.workQueueUi,
                    workQueueCache: nextState.workQueueCache,
                    preselectForms: nextState.preselectForms,
                    pushStateInterface: nextState.pushStateInterface,
                    step1: nextState.step1,
                    step2A: nextState.step2A,
                    step3: nextState.step3,
                    routeVersion: nextState.routeVersion,
                    operations: v.value1,
                    step2B: new App_State.Step2BLoading({
                        workQueueState: result.state.step2B.value0.workQueueState,
                        workQueueUi: result.state.step2B.value0.workQueueUi,
                        workQueueCache: result.state.step2B.value0.workQueueCache,
                        opId: new Data_Maybe.Just(v.value0)
                    })
                },
                commands: append(result.commands)([ new RunStep2BLoad(v.value0, result.state.step2B.value0.workQueueState, result.state.step2B.value0.workQueueUi, result.state.step2B.value0.workQueueCache) ])
            };
        };
        return result;
    };
    return scheduleStep3BootstrapOps(result);
};
var startStep2ExportAll = function (result) {
    if (App_Operation_Store.isScopeActive(result.state.operations)(App_Operation_Types.Step2ExportScope.value)) {
        return result;
    };
    if (Data_Boolean.otherwise) {
        var nextState = applyStep2OperationStartPolicy(App_Operation_Types.ExportStep2Forms.value)(result.state);
        var v = App_Operation_Store.startOperation(App_Operation_Types.ExportStep2Forms.value)(Data_Maybe.Nothing.value)(nextState.operations);
        return {
            state: {
                route: nextState.route,
                step: nextState.step,
                workQueueState: nextState.workQueueState,
                workQueueUi: nextState.workQueueUi,
                workQueueCache: nextState.workQueueCache,
                preselectForms: nextState.preselectForms,
                pushStateInterface: nextState.pushStateInterface,
                step1: nextState.step1,
                step2A: nextState.step2A,
                step2B: nextState.step2B,
                step3: nextState.step3,
                routeVersion: nextState.routeVersion,
                operations: v.value1
            },
            commands: append(result.commands)([ new RunStep2ExportAll(v.value0, nextState.workQueueState, nextState.workQueueCache) ])
        };
    };
    throw new Error("Failed pattern match at App.Update (line 594, column 1 - line 594, column 52): " + [ result.constructor.name ]);
};
var applyStep1OperationStartPolicy = function (kind) {
    return function (state) {
        return Data_Array.foldl(function (acc) {
            return function (scope) {
                return supersedeLatestActiveInScope(scope)(acc);
            };
        })(state)(supersededScopesForStep1Operation(kind));
    };
};
var scheduleBootstrapOps = function (result) {
    if (result.state.step instanceof App_Step.Step1 && hasHydrateCommand(result.commands)) {
        return result;
    };
    if (result.state.step instanceof App_Step.Step1) {
        if (result.state.step1 instanceof App_State.Step1Loading && result.state.step1.value0.opId instanceof Data_Maybe.Nothing) {
            var nextState = applyStep1OperationStartPolicy(App_Operation_Types.LoadRecentForms.value)(result.state);
            var v = App_Operation_Store.reserveOperationId(nextState.operations);
            return {
                state: {
                    route: nextState.route,
                    step: nextState.step,
                    workQueueState: nextState.workQueueState,
                    workQueueUi: nextState.workQueueUi,
                    workQueueCache: nextState.workQueueCache,
                    preselectForms: nextState.preselectForms,
                    pushStateInterface: nextState.pushStateInterface,
                    step2A: nextState.step2A,
                    step2B: nextState.step2B,
                    step3: nextState.step3,
                    routeVersion: nextState.routeVersion,
                    operations: v.value1,
                    step1: new App_State.Step1Loading({
                        init: result.state.step1.value0.init,
                        opId: new Data_Maybe.Just(v.value0)
                    })
                },
                commands: append(result.commands)([ new RunStep1InitialLoad(v.value0, result.state.step1.value0.init) ])
            };
        };
        return scheduleStep2BootstrapOps(result);
    };
    return scheduleStep2BootstrapOps(result);
};
var bootstrap = function (state) {
    return scheduleBootstrapOps({
        state: state,
        commands: [  ]
    });
};
var startStep1Operation = function (kind) {
    return function (mkCommand) {
        return function (prepare) {
            return function (result) {
                if (result.state.step1 instanceof App_State.Step1Ready) {
                    var nextState = applyStep1OperationStartPolicy(kind)(result.state);
                    var v = App_Operation_Store.startOperation(kind)(Data_Maybe.Nothing.value)(nextState.operations);
                    var nextReady = Steps_Step1_State.startLoading(prepare(result.state.step1.value0));
                    return {
                        state: setStep1Ready(nextReady)({
                            route: nextState.route,
                            step: nextState.step,
                            workQueueState: nextState.workQueueState,
                            workQueueUi: nextState.workQueueUi,
                            workQueueCache: nextState.workQueueCache,
                            preselectForms: nextState.preselectForms,
                            pushStateInterface: nextState.pushStateInterface,
                            step1: nextState.step1,
                            step2A: nextState.step2A,
                            step2B: nextState.step2B,
                            step3: nextState.step3,
                            routeVersion: nextState.routeVersion,
                            operations: v.value1
                        }),
                        commands: append(result.commands)([ mkCommand(v.value0)(nextReady) ])
                    };
                };
                return result;
            };
        };
    };
};
var applyRuntimeNavigation = function (nav) {
    return function (state) {
        if (nav instanceof App_Step.NavNext) {
            return {
                state: finishStepNavigation(state),
                shouldSyncRoute: true
            };
        };
        if (nav instanceof App_Step.NavCancel) {
            return {
                state: exitToHome(state),
                shouldSyncRoute: true
            };
        };
        if (nav instanceof App_Step.NavJump) {
            return {
                state: App_State.activateStep(nav.value0)(state),
                shouldSyncRoute: true
            };
        };
        throw new Error("Failed pattern match at App.Update (line 1165, column 36 - line 1179, column 10): " + [ nav.constructor.name ]);
    };
};
var appendCommand = function (command) {
    return function (result) {
        return {
            state: result.state,
            commands: append(result.commands)([ command ])
        };
    };
};
var allowStep1Message = {
    blockedByLoading: false,
    blockedByScopes: [  ]
};
var step1MessagePolicy = function (msg) {
    if (isStep1RecentFormsReloadMsg(msg)) {
        return {
            blockedByLoading: false,
            blockedByScopes: step1BlockingOperationScopes
        };
    };
    if (isStep1CreateFormsMsg(msg)) {
        return {
            blockedByLoading: false,
            blockedByScopes: step1BlockingOperationScopes
        };
    };
    if (isStep1DocumentMutationMsg(msg)) {
        return {
            blockedByLoading: true,
            blockedByScopes: [ App_Operation_Types.Step1GlobalScope.value ]
        };
    };
    if (isStep1FormOrderMsg(msg)) {
        return {
            blockedByLoading: false,
            blockedByScopes: [ App_Operation_Types.Step1GlobalScope.value ]
        };
    };
    if (isStep1GlobalActionMsg(msg)) {
        return {
            blockedByLoading: false,
            blockedByScopes: [ App_Operation_Types.Step1GlobalScope.value ]
        };
    };
    if (Data_Boolean.otherwise) {
        return allowStep1Message;
    };
    throw new Error("Failed pattern match at App.Update (line 814, column 1 - line 814, column 54): " + [ msg.constructor.name ]);
};
var shouldBlockStep1Message = function (ready) {
    return function (msg) {
        return function (state) {
            var policy = step1MessagePolicy(msg);
            return policy.blockedByLoading && isStep1Loading(ready) || Data_Array.any(App_Operation_Store.isScopeActive(state.operations))(policy.blockedByScopes);
        };
    };
};
var advanceRouteVersion = function (state) {
    return {
        route: state.route,
        step: state.step,
        workQueueState: state.workQueueState,
        workQueueUi: state.workQueueUi,
        workQueueCache: state.workQueueCache,
        preselectForms: state.preselectForms,
        pushStateInterface: state.pushStateInterface,
        operations: state.operations,
        step1: state.step1,
        step2A: state.step2A,
        step2B: state.step2B,
        step3: state.step3,
        routeVersion: state.routeVersion + 1 | 0
    };
};
var appendRouteCommand = function (command) {
    return function (result) {
        return appendCommand(command)({
            commands: result.commands,
            state: advanceRouteVersion(result.state)
        });
    };
};
var applyStep1RuntimeNavigation = function (step) {
    return function (prepare) {
        return function (result) {
            var state = supersedeLatestActiveInScope(App_Operation_Types.Step1RecentFormsScope.value)(result.state);
            var nextState = advanceRouteVersion(App_State.activateStep(step)(prepare(state)));
            return {
                state: nextState,
                commands: append(result.commands)([ new SyncRoute(App_State.PushRouteHistory.value) ])
            };
        };
    };
};
var applyStep1CreateForms = function (ready) {
    var teacherSelected = Data_Maybe.isJust(ready.formPicker.workQueueState.teacher);
    var isStudent = eq3(ready.formPicker.workQueueCache.account.type)(API_Account.StudentAccount.value);
    var selectSelf = function (v) {
        if (v instanceof Data_Maybe.Just && isStudent) {
            return select$prime(v.value0)(ready.formPicker.workQueueState.students);
        };
        return ready.formPicker.workQueueState.students;
    };
    var formsSelected = !isEmpty(ready.formPicker.workQueueState.forms);
    var nextStep = (function () {
        if (isStudent) {
            var $313 = formsSelected && teacherSelected;
            if ($313) {
                return App_Step.Step3.value;
            };
            return App_Step.Step2B.value;
        };
        return App_Step.Step2A.value;
    })();
    return applyStep1RuntimeNavigation(nextStep)(function (state) {
        return {
            route: state.route,
            step: state.step,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            workQueueState: {
                forms: ready.formPicker.workQueueState.forms,
                documents: ready.formPicker.workQueueState.documents,
                editDocs: ready.formPicker.workQueueState.editDocs,
                currentDoc: ready.formPicker.workQueueState.currentDoc,
                semester: ready.formPicker.workQueueState.semester,
                teacher: ready.formPicker.workQueueState.teacher,
                students: selectSelf(ready.formPicker.workQueueCache.account.student)
            },
            workQueueUi: {
                expandedStudents: ready.formPicker.workQueueUi.expandedStudents,
                teacher: ready.formPicker.workQueueUi.teacher,
                semester: ready.formPicker.workQueueUi.semester,
                search: ready.searchState
            },
            workQueueCache: ready.formPicker.workQueueCache
        };
    });
};
var applyStep1EditDocument = function (doc) {
    var editWorkQueue = function (docs) {
        return function (workQueue) {
            return Steps_WorkQueue_State.setCurrentDoc(Steps_WorkQueue_State.editDocsWorkQueue(workQueue)(docs))(new Data_Maybe.Just({
                formId: doc.form_type.id,
                studentId: doc.student.id,
                documentId: new Data_Maybe.Just(doc.id)
            }));
        };
    };
    return applyStep1RuntimeNavigation(App_Step.Step3.value)(function (state) {
        return {
            route: state.route,
            step: state.step,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            workQueueState: editWorkQueue([ doc ])(state.workQueueState)
        };
    });
};
var applyStep1EditDocuments = function (ready) {
    var selected = Steps_Step1_State.selectedForms(ready);
    var current = map1(function (doc) {
        return {
            formId: doc.form_type.id,
            studentId: doc.student.id,
            documentId: new Data_Maybe.Just(doc.id)
        };
    })(Data_Array.head(selected));
    return applyStep1RuntimeNavigation(App_Step.Step3.value)(function (state) {
        return {
            route: state.route,
            step: state.step,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            workQueueState: Steps_WorkQueue_State.setCurrentDoc(Steps_WorkQueue_State.editDocsWorkQueue(state.workQueueState)(selected))(current)
        };
    });
};
var applyStep2Navigation = function (nav) {
    return function (state) {
        return function (result) {
            var transition = applyRuntimeNavigation(nav)(state);
            var nextState = (function () {
                if (transition.shouldSyncRoute) {
                    return advanceRouteVersion(transition.state);
                };
                return transition.state;
            })();
            return {
                state: nextState,
                commands: (function () {
                    if (transition.shouldSyncRoute) {
                        return append(result.commands)([ new SyncRoute(App_State.PushRouteHistory.value) ]);
                    };
                    return result.commands;
                })()
            };
        };
    };
};
var applyStep2AAction = function (ready) {
    return function (action) {
        return function (result) {
            if (action instanceof Form_StudentSelect.StateChange) {
                var nextState = {
                    operations: result.state.operations,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    route: result.state.route,
                    routeVersion: result.state.routeVersion,
                    step: result.state.step,
                    step1: result.state.step1,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    workQueueCache: result.state.workQueueCache,
                    workQueueUi: result.state.workQueueUi,
                    workQueueState: {
                        currentDoc: result.state.workQueueState.currentDoc,
                        documents: result.state.workQueueState.documents,
                        editDocs: result.state.workQueueState.editDocs,
                        forms: result.state.workQueueState.forms,
                        semester: result.state.workQueueState.semester,
                        teacher: result.state.workQueueState.teacher,
                        students: action.value0.students
                    },
                    step2A: new App_State.Step2AReady(action.value0)
                };
                return {
                    commands: result.commands,
                    state: nextState
                };
            };
            if (action instanceof Form_StudentSelect.WorkQA && action.value0 instanceof Steps_WorkQueue_View.UIStateChange) {
                return {
                    commands: result.commands,
                    state: {
                        route: result.state.route,
                        step: result.state.step,
                        workQueueState: result.state.workQueueState,
                        workQueueCache: result.state.workQueueCache,
                        preselectForms: result.state.preselectForms,
                        pushStateInterface: result.state.pushStateInterface,
                        operations: result.state.operations,
                        step1: result.state.step1,
                        step2A: result.state.step2A,
                        step2B: result.state.step2B,
                        step3: result.state.step3,
                        routeVersion: result.state.routeVersion,
                        workQueueUi: action.value0.value0
                    }
                };
            };
            if (action instanceof Form_StudentSelect.WorkQA) {
                return result;
            };
            if (action instanceof Form_StudentSelect.QueueChanged) {
                return {
                    commands: result.commands,
                    state: {
                        route: result.state.route,
                        step: result.state.step,
                        workQueueCache: result.state.workQueueCache,
                        preselectForms: result.state.preselectForms,
                        pushStateInterface: result.state.pushStateInterface,
                        operations: result.state.operations,
                        step1: result.state.step1,
                        step2A: result.state.step2A,
                        step2B: result.state.step2B,
                        step3: result.state.step3,
                        routeVersion: result.state.routeVersion,
                        workQueueState: action.value0,
                        workQueueUi: action.value1
                    }
                };
            };
            if (action instanceof Form_StudentSelect.Done && Steps_WorkQueue_State.formForSelected(result.state.workQueueCache.account)(result.state.workQueueState)) {
                return applyStep2Navigation(App_Step.NavNext.value)(result.state)(result);
            };
            if (action instanceof Form_StudentSelect.Done) {
                return {
                    commands: result.commands,
                    state: {
                        route: result.state.route,
                        step: result.state.step,
                        workQueueState: result.state.workQueueState,
                        workQueueUi: result.state.workQueueUi,
                        workQueueCache: result.state.workQueueCache,
                        preselectForms: result.state.preselectForms,
                        pushStateInterface: result.state.pushStateInterface,
                        operations: result.state.operations,
                        step1: result.state.step1,
                        step2B: result.state.step2B,
                        step3: result.state.step3,
                        routeVersion: result.state.routeVersion,
                        step2A: new App_State.Step2AReady({
                            page: ready.page,
                            students: ready.students,
                            search: ready.search,
                            status: ready.status,
                            account: ready.account,
                            msg: new Data_Maybe.Just(Translate.lookupTranslation("must-select-teacher-semester"))
                        })
                    }
                };
            };
            if (action instanceof Form_StudentSelect.Cancel) {
                return applyStep2Navigation(App_Step.NavCancel.value)(result.state)(result);
            };
            if (action instanceof Form_StudentSelect.Export && Steps_WorkQueue_State.formForSelected(result.state.workQueueCache.account)(result.state.workQueueState)) {
                return startStep2ExportAll(result);
            };
            if (action instanceof Form_StudentSelect.Export) {
                return {
                    commands: result.commands,
                    state: {
                        route: result.state.route,
                        step: result.state.step,
                        workQueueState: result.state.workQueueState,
                        workQueueUi: result.state.workQueueUi,
                        workQueueCache: result.state.workQueueCache,
                        preselectForms: result.state.preselectForms,
                        pushStateInterface: result.state.pushStateInterface,
                        operations: result.state.operations,
                        step1: result.state.step1,
                        step2B: result.state.step2B,
                        step3: result.state.step3,
                        routeVersion: result.state.routeVersion,
                        step2A: new App_State.Step2AReady({
                            page: ready.page,
                            students: ready.students,
                            search: ready.search,
                            status: ready.status,
                            account: ready.account,
                            msg: new Data_Maybe.Just(Translate.lookupTranslation("must-select-teacher-semester"))
                        })
                    }
                };
            };
            throw new Error("Failed pattern match at App.Update (line 513, column 41 - line 543, column 139): " + [ action.constructor.name ]);
        };
    };
};
var applyStep2BAction = function (ready) {
    return function (action) {
        return function (result) {
            if (action instanceof Steps_FormPicker.State) {
                return {
                    commands: result.commands,
                    state: syncStep2BState(result.state)(action.value0)
                };
            };
            if (action instanceof Steps_FormPicker.WorkQR && action.value0 instanceof Steps_WorkQueue_View.UIStateChange) {
                return {
                    commands: result.commands,
                    state: syncStep2BState(result.state)({
                        forms: ready.forms,
                        workQueueState: ready.workQueueState,
                        workQueueCache: ready.workQueueCache,
                        reorder: ready.reorder,
                        movedDownIdx: ready.movedDownIdx,
                        workQueueUi: action.value0.value0
                    })
                };
            };
            if (action instanceof Steps_FormPicker.WorkQR) {
                return result;
            };
            if (action instanceof Steps_FormPicker.Navigate && (action.value0 instanceof App_Step.NavNext && !Steps_WorkQueue_State.formForSelected(ready.workQueueCache.account)(ready.workQueueState))) {
                return result;
            };
            if (action instanceof Steps_FormPicker.Navigate) {
                return applyStep2Navigation(action.value0)(syncStep2BState(result.state)(ready))(result);
            };
            if (action instanceof Steps_FormPicker.Export && Steps_WorkQueue_State.formForSelected(ready.workQueueCache.account)(ready.workQueueState)) {
                return startStep2ExportAll({
                    commands: result.commands,
                    state: syncStep2BState(result.state)(ready)
                });
            };
            if (action instanceof Steps_FormPicker.Export) {
                return result;
            };
            throw new Error("Failed pattern match at App.Update (line 546, column 41 - line 566, column 15): " + [ action.constructor.name ]);
        };
    };
};
var applyStep3Command = function (result) {
    return function (v) {
        if (v instanceof Steps_Step3_Update.SyncRoute) {
            return appendRouteCommand(new SyncStep3Route(v.value0))(result);
        };
        if (v instanceof Steps_Step3_Update.StartSave) {
            if (result.state.step3 instanceof App_State.Step3Ready) {
                return startStep3Operation(new Steps_Step3_Update.StartSave(v.value0))(new App_Operation_Types.SaveStep3Document(result.state.step3.value0.editor.fillState.doc.id))(v.value0)(function (opId) {
                    return new SaveStep3(opId, new App_Operation_Types.SaveStep3Document(result.state.step3.value0.editor.fillState.doc.id), v.value0);
                })(result);
            };
            return result;
        };
        if (v instanceof Steps_Step3_Update.StartLoad) {
            if (result.state.step3 instanceof App_State.Step3Ready) {
                var prepared = Steps_Step3_State.setPendingLoadTarget(v.value0)(result.state.step3.value0);
                return startStep3Operation(new Steps_Step3_Update.StartLoad(v.value0))(Steps_Step3_State.loadOperationKindForState(prepared))(new Data_Maybe.Just(v.value0.generation))(function (opId) {
                    return new LoadStep3(opId, Steps_Step3_State.loadOperationKindForState(prepared), v.value0);
                })(result);
            };
            return result;
        };
        if (v instanceof Steps_Step3_Update.StartAutofill) {
            if (result.state.step3 instanceof App_State.Step3Ready) {
                return startStep3Operation(new Steps_Step3_Update.StartAutofill(v.value0))(new App_Operation_Types.AutofillStep3Document(result.state.step3.value0.editor.fillState.doc.id))(Data_Maybe.Nothing.value)(function (opId) {
                    return new AutofillStep3(opId, new App_Operation_Types.AutofillStep3Document(result.state.step3.value0.editor.fillState.doc.id), v.value0);
                })(result);
            };
            return result;
        };
        if (v instanceof Steps_Step3_Update.StartToggleLock) {
            if (result.state.step3 instanceof App_State.Step3Ready) {
                return startStep3Operation(Steps_Step3_Update.StartToggleLock.value)(new App_Operation_Types.ToggleStep3DocumentLock(result.state.step3.value0.editor.fillState.doc.id))(Data_Maybe.Nothing.value)(function (opId) {
                    return new ToggleStep3Lock(opId, new App_Operation_Types.ToggleStep3DocumentLock(result.state.step3.value0.editor.fillState.doc.id));
                })(result);
            };
            return result;
        };
        if (v instanceof Steps_Step3_Update.StartDocumentMutation) {
            if (result.state.step3 instanceof App_State.Step3Ready) {
                var kind = step3DocumentMutationOperationKind(result.state.step3.value0.editor.fillState.doc.id)(v.value0);
                return startStep3Operation(new Steps_Step3_Update.StartDocumentMutation(v.value0))(kind)(Data_Maybe.Nothing.value)(function (opId) {
                    return new RunStep3DocumentMutation(opId, kind, v.value0);
                })(result);
            };
            return result;
        };
        if (v instanceof Steps_Step3_Update.ConfirmCancel) {
            return appendCommand(ConfirmStep3Cancel.value)(result);
        };
        if (v instanceof Steps_Step3_Update.AllowPageUnload) {
            return appendCommand(AllowPageUnload.value)(result);
        };
        if (v instanceof Steps_Step3_Update.BlockPageUnload) {
            return appendCommand(BlockPageUnload.value)(result);
        };
        if (v instanceof Steps_Step3_Update.OpenExportUrl) {
            return appendCommand(new OpenExportUrl(v.value0))(result);
        };
        if (v instanceof Steps_Step3_Update.Navigate) {
            var currentState = {
                operations: result.state.operations,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                route: result.state.route,
                routeVersion: result.state.routeVersion,
                step: result.state.step,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                step3: result.state.step3,
                workQueueState: step3WorkQueueState(result.state),
                workQueueUi: step3WorkQueueUi(result.state),
                workQueueCache: step3WorkQueueCache(result.state)
            };
            var transition = applyRuntimeNavigation(v.value0)(currentState);
            var nextState = (function () {
                if (transition.shouldSyncRoute) {
                    return advanceRouteVersion(transition.state);
                };
                return transition.state;
            })();
            return {
                state: nextState,
                commands: (function () {
                    if (transition.shouldSyncRoute) {
                        return append(result.commands)([ new SyncRoute(App_State.PushRouteHistory.value) ]);
                    };
                    return result.commands;
                })()
            };
        };
        if (v instanceof Steps_Step3_Update.MarkSuperseded) {
            return {
                commands: result.commands,
                state: {
                    route: result.state.route,
                    step: result.state.step,
                    workQueueState: result.state.workQueueState,
                    workQueueUi: result.state.workQueueUi,
                    workQueueCache: result.state.workQueueCache,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    step1: result.state.step1,
                    step2A: result.state.step2A,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    routeVersion: result.state.routeVersion,
                    operations: App_Operation_Store.markSuperseded(v.value0)(result.state.operations)
                }
            };
        };
        throw new Error("Failed pattern match at App.Update (line 1003, column 28 - line 1092, column 109): " + [ v.constructor.name ]);
    };
};
var applyStep3Commands = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray)(applyStep3Command);
var handleReadyStep3BrowserRoute = function (state) {
    return function (requested) {
        if (state.step3 instanceof App_State.Step3Ready && (requested instanceof App_Route.RStep3 && requested.value0.activeDoc instanceof Data_Maybe.Just)) {
            var sectionAnchor = function (v) {
                if (v instanceof App_Route.SectionSet) {
                    return new Data_Maybe.Just(v.value0);
                };
                return Data_Maybe.Nothing.value;
            };
            var normaliseStep3BrowserSection = function (v) {
                if (v instanceof App_Route.SectionSet) {
                    return new App_Route.SectionSet(v.value0);
                };
                return App_Route.SectionClear.value;
            };
            var maybeScrollStep3Commands = function (v) {
                if (v instanceof App_Route.SectionSet) {
                    return [ new ScrollStep3Section(v.value0) ];
                };
                return [  ];
            };
            var handleKnownRoute = function (forceRouteReplace) {
                var $359 = eq(requested.value0.activeDoc.value0)(state.step3.value0.editor.fillState.doc.id);
                if ($359) {
                    var routeCommands = (function () {
                        if (forceRouteReplace) {
                            return [ new SyncStep3Route(Steps_Step3_Transition.ReplaceStep3History.value) ];
                        };
                        return [  ];
                    })();
                    var nextSection = normaliseStep3BrowserSection(requested.value0.section);
                    var nextReady = {
                        autofillOperationId: state.step3.value0.autofillOperationId,
                        documentMutationOperationId: state.step3.value0.documentMutationOperationId,
                        loadOperationId: state.step3.value0.loadOperationId,
                        lockOperationId: state.step3.value0.lockOperationId,
                        pendingPostSave: state.step3.value0.pendingPostSave,
                        saveOperationId: state.step3.value0.saveOperationId,
                        editor: {
                            fillState: state.step3.value0.editor.fillState,
                            position: state.step3.value0.editor.position,
                            queue: state.step3.value0.editor.queue,
                            transitionState: state.step3.value0.editor.transitionState,
                            workQueueCache: state.step3.value0.editor.workQueueCache,
                            workQueueState: state.step3.value0.editor.workQueueState,
                            workQueueUi: state.step3.value0.editor.workQueueUi,
                            anchor: Data_Maybe.Nothing.value,
                            activeSection: sectionAnchor(nextSection),
                            sectionIntent: nextSection
                        }
                    };
                    var $361 = App_Route.sectionHash(sectionAnchor(nextSection)) === App_Route.sectionHash(sectionAnchor(state.step3.value0.editor.sectionIntent));
                    if ($361) {
                        return pure(new Data_Maybe.Just({
                            state: state,
                            commands: routeCommands
                        }));
                    };
                    return pure(new Data_Maybe.Just({
                        state: syncReadyState(state)(nextReady),
                        commands: append(maybeScrollStep3Commands(nextSection))(routeCommands)
                    }));
                };
                var v = step3DocRouteIndex(state.step3.value0)(requested.value0.activeDoc.value0);
                if (v instanceof Data_Maybe.Just) {
                    return bind(map2(browserRouteStep3Result)(Steps_Step3_Update.update(state.step3.value0)(new Steps_Step3_Update.ViewEvent(new Steps_Step3_Types.JumpIdxF(v.value0, sectionAnchor(normaliseStep3BrowserSection(requested.value0.section)))))))(function (step3Result) {
                        return pure(new Data_Maybe.Just(applyStep3Commands({
                            state: syncReadyState(state)(step3Result.state),
                            commands: [  ]
                        })(step3Result.commands)));
                    });
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return pure(Data_Maybe.Nothing.value);
                };
                throw new Error("Failed pattern match at App.Update (line 1294, column 22 - line 1305, column 37): " + [ v.constructor.name ]);
            };
            var requestedDocIds = nub(Data_Array.cons(requested.value0.activeDoc.value0)(requested.value0.docs));
            var $364 = step3RequestedDocIdsMatch(state.step3.value0)(requestedDocIds);
            if ($364) {
                return handleKnownRoute(false);
            };
            var $365 = Data_Array.all(function (docId$prime) {
                return elem(docId$prime)(step3DocIds(state.step3.value0));
            })(requestedDocIds);
            if ($365) {
                return handleKnownRoute(true);
            };
            return pure(Data_Maybe.Nothing.value);
        };
        return pure(Data_Maybe.Nothing.value);
    };
};
var acceptStep1Message = function (ready) {
    return function (msg) {
        return function (result) {
            if (invalidatesStep1SearchDebounce(msg)) {
                var nextReady = {
                    formPicker: ready.formPicker,
                    recentForms: ready.recentForms,
                    searchState: ready.searchState,
                    selection: ready.selection,
                    state: ready.state,
                    searchVersion: ready.searchVersion + 1 | 0
                };
                return {
                    ready: nextReady,
                    result: {
                        commands: result.commands,
                        state: setStep1Ready(nextReady)(result.state)
                    }
                };
            };
            if (Data_Boolean.otherwise) {
                return {
                    ready: ready,
                    result: result
                };
            };
            throw new Error("Failed pattern match at App.Update (line 777, column 1 - line 781, column 66): " + [ ready.constructor.name, msg.constructor.name, result.constructor.name ]);
        };
    };
};
var applyStep1Msg = function (ready0) {
    return function (msg) {
        return function (result0) {
            if (shouldBlockStep1Message(ready0)(msg)(result0.state)) {
                return result0;
            };
            if (Data_Boolean.otherwise) {
                var accepted = acceptStep1Message(ready0)(msg)(result0);
                if (msg instanceof Steps_Step1_Update.StateChanged) {
                    return {
                        commands: accepted.result.commands,
                        state: setStep1Ready({
                            recentForms: msg.value0.recentForms,
                            selection: msg.value0.selection,
                            searchState: msg.value0.searchState,
                            formPicker: msg.value0.formPicker,
                            state: msg.value0.state,
                            searchVersion: accepted.ready.searchVersion
                        })(accepted.result.state)
                    };
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.SearchChanged) {
                    var nextState = supersedeLatestActiveInScope(App_Operation_Types.Step1RecentFormsScope.value)(accepted.result.state);
                    var nextReady = Steps_Step1_State.applySearchChanged(msg.value0.value0)(accepted.ready);
                    return {
                        state: setStep1Ready(nextReady)(nextState),
                        commands: append(accepted.result.commands)([ new DebounceStep1Search(nextReady.searchVersion) ])
                    };
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && (msg.value0 instanceof Steps_Step1_Update.FormPickerChanged && msg.value0.value0.reorder)) {
                    return {
                        commands: accepted.result.commands,
                        state: setStep1Ready({
                            recentForms: accepted.ready.recentForms,
                            selection: accepted.ready.selection,
                            searchState: accepted.ready.searchState,
                            state: accepted.ready.state,
                            searchVersion: accepted.ready.searchVersion,
                            formPicker: msg.value0.value0
                        })(accepted.result.state)
                    };
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.FormPickerChanged) {
                    return startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (opId) {
                        return function (nextReady) {
                            return new RunStep1Search(opId, nextReady);
                        };
                    })(function (st) {
                        return {
                            recentForms: st.recentForms,
                            searchState: st.searchState,
                            state: st.state,
                            searchVersion: st.searchVersion,
                            formPicker: msg.value0.value0,
                            selection: Internal_SelectionMap.empty
                        };
                    })(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.StartFormReorder) {
                    return {
                        commands: accepted.result.commands,
                        state: setStep1Ready({
                            recentForms: accepted.ready.recentForms,
                            selection: accepted.ready.selection,
                            searchState: accepted.ready.searchState,
                            state: accepted.ready.state,
                            searchVersion: accepted.ready.searchVersion,
                            formPicker: Steps_FormPicker.setFormReorder(accepted.ready.formPicker)(true)
                        })(accepted.result.state)
                    };
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.SaveFormOrder) {
                    return startStep1Operation(App_Operation_Types.SaveStep1FormOrder.value)(function (opId) {
                        return function (nextReady) {
                            return new RunStep1SaveFormOrder(opId, nextReady);
                        };
                    })(function (st) {
                        return {
                            recentForms: st.recentForms,
                            selection: st.selection,
                            searchState: st.searchState,
                            state: st.state,
                            searchVersion: st.searchVersion,
                            formPicker: {
                                forms: st.formPicker.forms,
                                workQueueState: st.formPicker.workQueueState,
                                workQueueUi: st.formPicker.workQueueUi,
                                workQueueCache: st.formPicker.workQueueCache,
                                reorder: st.formPicker.reorder,
                                movedDownIdx: Data_Maybe.Nothing.value
                            }
                        };
                    })(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.ChangePage) {
                    return startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (opId) {
                        return function (nextReady) {
                            return new RunStep1PageChange(opId, nextReady, msg.value0.value0);
                        };
                    })(function (st) {
                        return {
                            recentForms: st.recentForms,
                            searchState: st.searchState,
                            formPicker: st.formPicker,
                            state: st.state,
                            searchVersion: st.searchVersion,
                            selection: Internal_SelectionMap.empty
                        };
                    })(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && (msg.value0 instanceof Steps_Step1_Update.EditDocument && msg.value0.value0.legacy_url instanceof Data_Maybe.Just)) {
                    return appendCommand(new OpenExternalUrl(msg.value0.value0.legacy_url.value0))(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.EditDocument) {
                    return applyStep1EditDocument(msg.value0.value0)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.EditDocuments) {
                    return applyStep1EditDocuments(accepted.ready)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.ToggleDocumentLocks) {
                    var v = Steps_Step1_Update.toggleLockRequests(accepted.ready);
                    if (v instanceof Data_Maybe.Nothing) {
                        return accepted.result;
                    };
                    if (v instanceof Data_Maybe.Just) {
                        return startStep1Operation(new App_Operation_Types.BulkToggleDocumentLocks(Steps_Step1_State.selectedDocumentIds(accepted.ready)))(function (opId) {
                            return function (nextReady) {
                                return new RunStep1ToggleLocks(opId, nextReady);
                            };
                        })(identity)(accepted.result);
                    };
                    throw new Error("Failed pattern match at App.Update (line 696, column 51 - line 704, column 23): " + [ v.constructor.name ]);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.ExportDocuments) {
                    return startStep1Operation(new App_Operation_Types.ExportRecentForms(Steps_Step1_State.selectedDocumentIds(accepted.ready)))(function (opId) {
                        return function (nextReady) {
                            return new RunStep1ExportDocuments(opId, nextReady, msg.value0.value0);
                        };
                    })(identity)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.CreateForms) {
                    return applyStep1CreateForms(accepted.ready)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.CopyDocuments) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.DeleteDocuments) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.RequestSignatures) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.ViewAction && msg.value0 instanceof Steps_Step1_Update.UpdateForms) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.CopyStudentsSelected && msg.value0 instanceof Data_Maybe.Nothing) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.CopyStudentsSelected && msg.value0 instanceof Data_Maybe.Just) {
                    return startStep1Operation(new App_Operation_Types.CopyRecentForms(Steps_Step1_State.selectedDocumentIds(accepted.ready)))(function (opId) {
                        return function (nextReady) {
                            return new RunStep1CopyDocuments(opId, nextReady, Steps_Step1_Update.copyRequests(accepted.ready)(msg.value0.value0));
                        };
                    })(identity)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.DeleteConfirmed && !msg.value0) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.DeleteConfirmed && msg.value0) {
                    return startStep1Operation(new App_Operation_Types.DeleteRecentForms(Steps_Step1_State.selectedDocumentIds(accepted.ready)))(function (opId) {
                        return function (nextReady) {
                            return new RunStep1DeleteDocuments(opId, nextReady);
                        };
                    })(identity)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.SignatureRequestsSelected && msg.value0 instanceof Data_Maybe.Nothing) {
                    return {
                        commands: accepted.result.commands,
                        state: setStep1Ready({
                            recentForms: accepted.ready.recentForms,
                            searchState: accepted.ready.searchState,
                            formPicker: accepted.ready.formPicker,
                            state: accepted.ready.state,
                            searchVersion: accepted.ready.searchVersion,
                            selection: Internal_SelectionMap.empty
                        })(accepted.result.state)
                    };
                };
                if (msg instanceof Steps_Step1_Update.SignatureRequestsSelected && msg.value0 instanceof Data_Maybe.Just) {
                    return startStep1Operation(new App_Operation_Types.RequestRecentFormSignatures(map(function (v) {
                        return v.docId;
                    })(msg.value0.value0)))(function (opId) {
                        return function (v) {
                            return new RunStep1RequestSignatures(opId, msg.value0.value0);
                        };
                    })(identity)(accepted.result);
                };
                if (msg instanceof Steps_Step1_Update.FormsUpdateSelected && msg.value0 instanceof Data_Maybe.Nothing) {
                    return accepted.result;
                };
                if (msg instanceof Steps_Step1_Update.FormsUpdateSelected && msg.value0 instanceof Data_Maybe.Just) {
                    return startStep1Operation(new App_Operation_Types.UpdateRecentForms(Steps_Step1_State.selectedDocumentIds(accepted.ready)))(function (opId) {
                        return function (nextReady) {
                            return new RunStep1UpdateForms(opId, nextReady, msg.value0.value0);
                        };
                    })(identity)(accepted.result);
                };
                throw new Error("Failed pattern match at App.Update (line 648, column 12 - line 766, column 19): " + [ msg.constructor.name ]);
            };
            throw new Error("Failed pattern match at App.Update (line 639, column 1 - line 639, column 84): " + [ ready0.constructor.name, msg.constructor.name, result0.constructor.name ]);
        };
    };
};
var update = function (state) {
    return function (msg) {
        return map2(scheduleBootstrapOps)((function () {
            if (msg instanceof App_Msg.BrowserLocationChanged) {
                var requested = App_Route.parseRoute(msg.value0);
                var nextState = advanceRouteVersion(state);
                var expected = currentRouteForState(state)(msg.value0);
                return bind(handleReadyStep3BrowserRoute(nextState)(requested))(function (handled) {
                    if (handled instanceof Data_Maybe.Just) {
                        return pure(handled.value0);
                    };
                    if (handled instanceof Data_Maybe.Nothing && App_Route.routeUrl(requested) === App_Route.routeUrl(expected)) {
                        return pure({
                            state: nextState,
                            commands: [  ]
                        });
                    };
                    if (handled instanceof Data_Maybe.Nothing) {
                        return pure({
                            state: nextState,
                            commands: [ new HydrateLocation(nextState.routeVersion, msg.value0) ]
                        });
                    };
                    throw new Error("Failed pattern match at App.Update (line 95, column 13 - line 104, column 26): " + [ handled.constructor.name ]);
                });
            };
            if (msg instanceof App_Msg.HydratedLocation) {
                var $424 = msg.value0 !== state.routeVersion;
                if ($424) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                return bind(msg.value2)(function (nextState) {
                    var requested = App_Route.parseRoute(msg.value1);
                    var routeCommands = (function () {
                        var $425 = App_Route.routeUrl(requested) === App_Route.routeUrl(nextState.route);
                        if ($425) {
                            return [  ];
                        };
                        return [ new SyncRoute(App_State.ReplaceRouteHistory.value) ];
                    })();
                    return pure({
                        state: nextState,
                        commands: routeCommands
                    });
                });
            };
            if (msg instanceof App_Msg.Step1Msg) {
                if (state.step instanceof App_Step.Step1) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        return pure(applyStep1Msg(state.step1.value0)(msg.value0)({
                            state: state,
                            commands: [  ]
                        }));
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step1SearchDebounced) {
                if (state.step instanceof App_Step.Step1) {
                    if (state.step1 instanceof App_State.Step1Ready && state.step1.value0.searchVersion === msg.value0) {
                        return pure(startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (opId) {
                            return function (nextReady) {
                                return new RunStep1Search(opId, nextReady);
                            };
                        })(identity)({
                            state: state,
                            commands: [  ]
                        }));
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step1InitialLoaded) {
                if (state.step1 instanceof App_State.Step1Loading && (state.step1.value0.opId instanceof Data_Maybe.Just && eq2(state.step1.value0.opId.value0)(msg.value0))) {
                    return bind(msg.value1)(function (ready) {
                        return pure({
                            state: setStep1Ready(ready)({
                                route: state.route,
                                step: state.step,
                                workQueueState: state.workQueueState,
                                workQueueUi: state.workQueueUi,
                                workQueueCache: state.workQueueCache,
                                pushStateInterface: state.pushStateInterface,
                                operations: state.operations,
                                step1: state.step1,
                                step2A: state.step2A,
                                step2B: state.step2B,
                                step3: state.step3,
                                routeVersion: state.routeVersion,
                                preselectForms: [  ]
                            }),
                            commands: [  ]
                        });
                    });
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step1RecentFormsLoaded) {
                if (!isCurrentOperation(App_Operation_Types.Step1RecentFormsScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value1 instanceof Data_Either.Right) {
                            return pure({
                                state: setStep1Ready(Steps_Step1_State.applyRecentFormsPage(msg.value1.value0)(state.step1.value0))(state),
                                commands: [  ]
                            });
                        };
                        if (msg.value1 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value1.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 157, column 33 - line 164, column 48): " + [ msg.value1.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1FormOrderSaved) {
                if (!isLatestOperation(App_Operation_Types.Step1FormOrderScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value1 instanceof Data_Either.Right) {
                            return pure({
                                state: setStep1Ready(Steps_Step1_State.finishLoading({
                                    recentForms: state.step1.value0.recentForms,
                                    selection: state.step1.value0.selection,
                                    searchState: state.step1.value0.searchState,
                                    state: state.step1.value0.state,
                                    searchVersion: state.step1.value0.searchVersion,
                                    formPicker: msg.value1.value0
                                }))(state),
                                commands: [  ]
                            });
                        };
                        if (msg.value1 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value1.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 172, column 33 - line 179, column 48): " + [ msg.value1.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1LocksToggled) {
                if (!isLatestOperation(App_Operation_Types.Step1DocumentMutationScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value1 instanceof Data_Either.Right) {
                            return pure({
                                state: setStep1Ready(Steps_Step1_State.finishLoading(Steps_Step1_Update.applyToggleLockResults(msg.value1.value0)(state.step1.value0)))(state),
                                commands: [  ]
                            });
                        };
                        if (msg.value1 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value1.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 187, column 33 - line 194, column 48): " + [ msg.value1.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1DocumentsCopied) {
                if (!isLatestOperation(App_Operation_Types.Step1DocumentMutationScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value1 instanceof Data_Either.Right) {
                            return pure(startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (nextOpId) {
                                return function (nextReady) {
                                    return new RunStep1PageChange(nextOpId, nextReady, 0);
                                };
                            })(function (st) {
                                return {
                                    recentForms: st.recentForms,
                                    searchState: st.searchState,
                                    formPicker: st.formPicker,
                                    state: st.state,
                                    searchVersion: st.searchVersion,
                                    selection: Internal_SelectionMap.empty
                                };
                            })({
                                state: state,
                                commands: [  ]
                            }));
                        };
                        if (msg.value1 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value1.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 202, column 29 - line 210, column 48): " + [ msg.value1.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1DocumentsDeleted) {
                if (!isLatestOperation(App_Operation_Types.Step1DocumentMutationScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value1 instanceof Data_Either.Right) {
                            return pure(startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (nextOpId) {
                                return function (nextReady) {
                                    return new RunStep1Search(nextOpId, nextReady);
                                };
                            })(function (st) {
                                return {
                                    recentForms: st.recentForms,
                                    searchState: st.searchState,
                                    formPicker: st.formPicker,
                                    state: st.state,
                                    searchVersion: st.searchVersion,
                                    selection: Internal_SelectionMap.empty
                                };
                            })({
                                state: state,
                                commands: [  ]
                            }));
                        };
                        if (msg.value1 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value1.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 218, column 29 - line 226, column 48): " + [ msg.value1.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1DocumentsExported) {
                if (!isLatestOperation(App_Operation_Types.Step1ExportScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value2 instanceof Data_Either.Right) {
                            var v = Steps_Step1_Update.findExportReport(msg.value1)(msg.value2.value0);
                            if (v instanceof Data_Maybe.Just) {
                                return pure({
                                    state: setStep1Ready(Steps_Step1_State.finishLoading(state.step1.value0))(state),
                                    commands: [ new OpenExportUrl(v.value0.url) ]
                                });
                            };
                            if (v instanceof Data_Maybe.Nothing) {
                                return pure(step1Error(new $$Error.WithContext(new $$Error.InModule("Steps.Step1"), new $$Error.WithContext(new $$Error.DuringAction("exporting documents"), new $$Error.StringError("Expected at least one report for exported documents."))))(state));
                            };
                            throw new Error("Failed pattern match at App.Update (line 235, column 34 - line 246, column 34): " + [ v.constructor.name ]);
                        };
                        if (msg.value2 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value2.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 234, column 33 - line 248, column 48): " + [ msg.value2.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1SignaturesRequested) {
                if (!isLatestOperation(App_Operation_Types.Step1DocumentMutationScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value1 instanceof Data_Either.Right) {
                            return pure(startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (nextOpId) {
                                return function (nextReady) {
                                    return new RunStep1CurrentPageReload(nextOpId, nextReady);
                                };
                            })(function (st) {
                                return {
                                    recentForms: st.recentForms,
                                    searchState: st.searchState,
                                    formPicker: st.formPicker,
                                    state: st.state,
                                    searchVersion: st.searchVersion,
                                    selection: Internal_SelectionMap.empty
                                };
                            })({
                                state: state,
                                commands: [  ]
                            }));
                        };
                        if (msg.value1 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value1.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 256, column 29 - line 264, column 48): " + [ msg.value1.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step1FormsUpdated) {
                if (!isLatestOperation(App_Operation_Types.Step1DocumentMutationScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (state.step1 instanceof App_State.Step1Ready) {
                        if (msg.value2 instanceof Data_Either.Right) {
                            return pure(startStep1Operation(App_Operation_Types.LoadRecentForms.value)(function (nextOpId) {
                                return function (nextReady) {
                                    return new RunStep1Search(nextOpId, nextReady);
                                };
                            })(function (st) {
                                return Steps_Step1_Update.applyFormsUpdateSelection(msg.value1)({
                                    recentForms: st.recentForms,
                                    searchState: st.searchState,
                                    formPicker: st.formPicker,
                                    state: st.state,
                                    searchVersion: st.searchVersion,
                                    selection: Internal_SelectionMap.empty
                                });
                            })({
                                state: setStep1Ready(state.step1.value0)(state),
                                commands: [  ]
                            }));
                        };
                        if (msg.value2 instanceof Data_Either.Left) {
                            return pure(step1Error(msg.value2.value0)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 272, column 33 - line 282, column 48): " + [ msg.value2.constructor.name ]);
                    };
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
            };
            if (msg instanceof App_Msg.Step2AAction) {
                if (state.step instanceof App_Step.Step2A && state.step2A instanceof App_State.Step2AReady) {
                    return pure(applyStep2AAction(state.step2A.value0)(msg.value0)({
                        state: state,
                        commands: [  ]
                    }));
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step2AInitialLoaded) {
                if (state.step2A instanceof App_State.Step2ALoading && (state.step2A.value0.opId instanceof Data_Maybe.Just && eq2(state.step2A.value0.opId.value0)(msg.value0))) {
                    if (msg.value1 instanceof Data_Either.Right) {
                        return pure({
                            state: {
                                operations: state.operations,
                                preselectForms: state.preselectForms,
                                pushStateInterface: state.pushStateInterface,
                                route: state.route,
                                routeVersion: state.routeVersion,
                                step: state.step,
                                step1: state.step1,
                                step2B: state.step2B,
                                step3: state.step3,
                                workQueueCache: state.workQueueCache,
                                workQueueUi: state.workQueueUi,
                                step2A: new App_State.Step2AReady(msg.value1.value0),
                                workQueueState: {
                                    currentDoc: state.workQueueState.currentDoc,
                                    documents: state.workQueueState.documents,
                                    editDocs: state.workQueueState.editDocs,
                                    forms: state.workQueueState.forms,
                                    semester: state.workQueueState.semester,
                                    teacher: state.workQueueState.teacher,
                                    students: msg.value1.value0.students
                                }
                            },
                            commands: [  ]
                        });
                    };
                    if (msg.value1 instanceof Data_Either.Left) {
                        return pure({
                            state: {
                                operations: state.operations,
                                preselectForms: state.preselectForms,
                                pushStateInterface: state.pushStateInterface,
                                route: state.route,
                                routeVersion: state.routeVersion,
                                step: state.step,
                                step1: state.step1,
                                step2B: state.step2B,
                                step3: state.step3,
                                workQueueCache: state.workQueueCache,
                                workQueueState: state.workQueueState,
                                workQueueUi: state.workQueueUi,
                                step2A: new App_State.Step2ALoadFailed(msg.value1.value0)
                            },
                            commands: [  ]
                        });
                    };
                    throw new Error("Failed pattern match at App.Update (line 293, column 75 - line 306, column 22): " + [ msg.value1.constructor.name ]);
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step2BAction) {
                if (state.step instanceof App_Step.Step2B && state.step2B instanceof App_State.Step2BReady) {
                    return pure(applyStep2BAction(state.step2B.value0)(msg.value0)({
                        state: state,
                        commands: [  ]
                    }));
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step2BLoaded) {
                if (state.step2B instanceof App_State.Step2BLoading && (state.step2B.value0.opId instanceof Data_Maybe.Just && eq2(state.step2B.value0.opId.value0)(msg.value0))) {
                    if (msg.value1 instanceof Data_Either.Right) {
                        return pure({
                            state: syncStep2BState(state)(msg.value1.value0),
                            commands: [  ]
                        });
                    };
                    if (msg.value1 instanceof Data_Either.Left) {
                        return pure({
                            state: {
                                operations: state.operations,
                                preselectForms: state.preselectForms,
                                pushStateInterface: state.pushStateInterface,
                                route: state.route,
                                routeVersion: state.routeVersion,
                                step: state.step,
                                step1: state.step1,
                                step2A: state.step2A,
                                step3: state.step3,
                                workQueueCache: state.workQueueCache,
                                workQueueState: state.workQueueState,
                                workQueueUi: state.workQueueUi,
                                step2B: new App_State.Step2BLoadFailed(msg.value1.value0)
                            },
                            commands: [  ]
                        });
                    };
                    throw new Error("Failed pattern match at App.Update (line 317, column 75 - line 327, column 22): " + [ msg.value1.constructor.name ]);
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step2FormsExported) {
                if (!isLatestOperation(App_Operation_Types.Step2ExportScope.value)(msg.value0)(state)) {
                    return pure({
                        state: state,
                        commands: [  ]
                    });
                };
                if (Data_Boolean.otherwise) {
                    if (msg.value1 instanceof Data_Either.Right) {
                        var v = Data_Array.head(msg.value1.value0);
                        if (v instanceof Data_Maybe.Just) {
                            var exportResult = {
                                state: state,
                                commands: [ new OpenExportUrl(v.value0.url) ]
                            };
                            return pure((function () {
                                var $531 = isCurrentStep2(state.step);
                                if ($531) {
                                    return applyStep2Navigation(App_Step.NavCancel.value)(state)(exportResult);
                                };
                                return exportResult;
                            })());
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return pure(step2ExportError(missingStep2ExportReportError)(state));
                        };
                        throw new Error("Failed pattern match at App.Update (line 335, column 30 - line 347, column 57): " + [ v.constructor.name ]);
                    };
                    if (msg.value1 instanceof Data_Either.Left) {
                        return pure(step2ExportError(msg.value1.value0)(state));
                    };
                    throw new Error("Failed pattern match at App.Update (line 334, column 24 - line 349, column 50): " + [ msg.value1.constructor.name ]);
                };
            };
            if (msg instanceof App_Msg.Step3FormTypesLoaded) {
                if (state.step3 instanceof App_State.Step3LoadingFormTypes && (state.step3.value0.opId instanceof Data_Maybe.Just && eq2(state.step3.value0.opId.value0)(msg.value0))) {
                    return bind(msg.value1)(function (preload) {
                        var nextState = {
                            operations: state.operations,
                            preselectForms: state.preselectForms,
                            pushStateInterface: state.pushStateInterface,
                            route: state.route,
                            routeVersion: state.routeVersion,
                            step: state.step,
                            step1: state.step1,
                            step2A: state.step2A,
                            step2B: state.step2B,
                            workQueueUi: state.workQueueUi,
                            workQueueState: preload.state,
                            workQueueCache: preload.cache,
                            step3: new App_State.Step3LoadingInitialState({
                                init: state.step3.value0.init,
                                opId: Data_Maybe.Nothing.value
                            })
                        };
                        return pure({
                            state: nextState,
                            commands: [  ]
                        });
                    });
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step3InitialLoaded) {
                if (state.step3 instanceof App_State.Step3LoadingInitialState && (state.step3.value0.opId instanceof Data_Maybe.Just && eq2(state.step3.value0.opId.value0)(msg.value0))) {
                    return bind(msg.value1)(function (ready) {
                        return pure(appendRouteCommand(new SyncStep3Route(Steps_Step3_Transition.ReplaceStep3History.value))({
                            state: syncReadyState(state)(ready),
                            commands: [  ]
                        }));
                    });
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step3Msg) {
                if (state.step3 instanceof App_State.Step3Ready) {
                    return bind(Steps_Step3_Update.update(state.step3.value0)(msg.value0))(function (step3Result) {
                        return pure(applyStep3Commands({
                            state: syncReadyState(state)(step3Result.state),
                            commands: [  ]
                        })(step3Result.commands));
                    });
                };
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.Step3DocumentRequestHandled) {
                return pure({
                    state: state,
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.OpStarted) {
                return pure({
                    state: {
                        preselectForms: state.preselectForms,
                        pushStateInterface: state.pushStateInterface,
                        route: state.route,
                        routeVersion: state.routeVersion,
                        step: state.step,
                        step1: state.step1,
                        step2A: state.step2A,
                        step2B: state.step2B,
                        step3: state.step3,
                        workQueueCache: state.workQueueCache,
                        workQueueState: state.workQueueState,
                        workQueueUi: state.workQueueUi,
                        operations: App_Operation_Store.recordStartedOperation(msg.value0)(msg.value1)(msg.value2)(state.operations)
                    },
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.OpCompleted) {
                return pure({
                    state: {
                        preselectForms: state.preselectForms,
                        pushStateInterface: state.pushStateInterface,
                        route: state.route,
                        routeVersion: state.routeVersion,
                        step: state.step,
                        step1: state.step1,
                        step2A: state.step2A,
                        step2B: state.step2B,
                        step3: state.step3,
                        workQueueCache: state.workQueueCache,
                        workQueueState: state.workQueueState,
                        workQueueUi: state.workQueueUi,
                        operations: App_Operation_Store.completeOperation(msg.value0)(new Data_Either.Right(Data_Unit.unit))(state.operations)
                    },
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.OpFailed) {
                return pure({
                    state: {
                        preselectForms: state.preselectForms,
                        pushStateInterface: state.pushStateInterface,
                        route: state.route,
                        routeVersion: state.routeVersion,
                        step: state.step,
                        step1: state.step1,
                        step2A: state.step2A,
                        step2B: state.step2B,
                        step3: state.step3,
                        workQueueCache: state.workQueueCache,
                        workQueueState: state.workQueueState,
                        workQueueUi: state.workQueueUi,
                        operations: App_Operation_Store.completeOperation(msg.value0)(new Data_Either.Left(msg.value1))(state.operations)
                    },
                    commands: [  ]
                });
            };
            if (msg instanceof App_Msg.OpSuperseded) {
                return pure({
                    state: {
                        preselectForms: state.preselectForms,
                        pushStateInterface: state.pushStateInterface,
                        route: state.route,
                        routeVersion: state.routeVersion,
                        step: state.step,
                        step1: state.step1,
                        step2A: state.step2A,
                        step2B: state.step2B,
                        step3: state.step3,
                        workQueueCache: state.workQueueCache,
                        workQueueState: state.workQueueState,
                        workQueueUi: state.workQueueUi,
                        operations: App_Operation_Store.markSuperseded(msg.value0)(state.operations)
                    },
                    commands: [  ]
                });
            };
            throw new Error("Failed pattern match at App.Update (line 87, column 47 - line 411, column 14): " + [ msg.constructor.name ]);
        })());
    };
};
export {
    SyncRoute,
    HydrateLocation,
    RunStep1InitialLoad,
    DebounceStep1Search,
    RunStep1Search,
    RunStep1PageChange,
    RunStep1CurrentPageReload,
    RunStep1SaveFormOrder,
    RunStep1ToggleLocks,
    RunStep1CopyDocuments,
    RunStep1DeleteDocuments,
    RunStep1ExportDocuments,
    RunStep1RequestSignatures,
    RunStep1UpdateForms,
    RunStep2AInitialLoad,
    RunStep2BLoad,
    RunStep2ExportAll,
    RunStep3FormTypesLoad,
    RunStep3InitialLoad,
    SyncStep3Route,
    ScrollStep3Section,
    SaveStep3,
    LoadStep3,
    AutofillStep3,
    ToggleStep3Lock,
    RunStep3DocumentMutation,
    ConfirmStep3Cancel,
    AllowPageUnload,
    BlockPageUnload,
    OpenExportUrl,
    OpenExternalUrl,
    ReportError,
    bootstrap,
    update
};
//# sourceMappingURL=index.js.map
